import { render, staticRenderFns } from "./learning.vue?vue&type=template&id=0b4dba83&scoped=true&"
import script from "./learning.vue?vue&type=script&lang=js&"
export * from "./learning.vue?vue&type=script&lang=js&"
import style0 from "./learning.vue?vue&type=style&index=0&id=0b4dba83&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4dba83",
  null
  
)

export default component.exports